import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useTenantConfig } from "../composables/useTenantConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Privacy',
  setup(__props) {

const { privacyText } = useTenantConfig();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: _unref(privacyText) }, null, 8, _hoisted_1))
}
}

})